__turbopack_context__.v({
  "author": "pkx8SG_author",
  "closeButton": "pkx8SG_closeButton",
  "closed": "pkx8SG_closed",
  "expansion": "pkx8SG_expansion",
  "fullOpen": "pkx8SG_fullOpen",
  "glossary": "pkx8SG_glossary",
  "hidden": "pkx8SG_hidden",
  "infoAccordionItem": "pkx8SG_infoAccordionItem",
  "initial": "pkx8SG_initial",
  "readButton": "pkx8SG_readButton",
  "secondary": "pkx8SG_secondary",
  "termTitle": "pkx8SG_termTitle",
  "video": "pkx8SG_video",
  "visible": "pkx8SG_visible",
});
